export default function charge_types(state = null, action) {
    switch (action.type) {
        case 'CHARGE_TYPES/SET': return action.charge_types;
        case 'CHARGE_TYPES/CLEAR': return null;
        default: return state;
    }
}
